export { default as PersonCard } from './PersonCard';
export type { PersonCardModel, PersonCardProps } from './PersonCard';
